<div class="p-2">
  <kendo-slider
    [fixedTickWidth]="40"
    [max]="1.25"
    [min]="0.625"
    [title]="fontSizeMap"
    [largeStep]="0.125"
    [smallStep]="0.125"
    (ngModelChange)="changeFontSize($event)"
    [(ngModel)]="fontSize"
  ></kendo-slider>
</div>
